import axios from "axios";
import config from "./config";

const FileApi = {

    post: async (file: any) => {

        const uri = config.host + '/api/private/file';
        const formData = new FormData();
        formData.append("file", file);
        try {
            const axiosConfig = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                }
            };
            const response = await axios.post(uri, formData, axiosConfig);
            return response.data;
        } catch (error) {
            throw new Error('Unable to post FileApi');
        }

    },

    postMultiple: async (files: any) => {

        const uri = config.host + '/api/private/files';
        const formData = new FormData();

        [...files].forEach((file, i) => {
            formData.append(`file-${i}`, file, file.name)
        });

        formData.append('count', files.length);

        //formData.append("files", files);
        try {
            const axiosConfig = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                }
            };
            const response = await axios.post(uri, formData, axiosConfig);
            return response.data;
        } catch (error) {
            throw new Error('Unable to post FileApi');
        }

    },

    get: async (id: number) => {

    }

}


export default FileApi;
